var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAdminTime = function SvgAdminTime(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2 2C6.53726 2 6 2.59081 6 3.31961V5.40195C6 9.04595 8.68629 12 12 12C15.3137 12 18 9.04595 18 5.40195V3.31961C18 2.59081 17.4627 2 16.8 2H7.2Z",
    stroke: "#3F85EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2 22C6.53726 22 6 21.4092 6 20.6804V18.598C6 14.954 8.68629 12 12 12C15.3137 12 18 14.954 18 18.598V20.6804C18 21.4092 17.4627 22 16.8 22H7.2Z",
    stroke: "#3F85EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22C16.0195 19.9048 15 18 12 18C9 18 7.98045 19.9048 7 22",
    stroke: "#3F85EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAdminTime);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjIgMkM2LjUzNzI2IDIgNiAyLjU5MDgxIDYgMy4zMTk2MVY1LjQwMTk1QzYgOS4wNDU5NSA4LjY4NjI5IDEyIDEyIDEyQzE1LjMxMzcgMTIgMTggOS4wNDU5NSAxOCA1LjQwMTk1VjMuMzE5NjFDMTggMi41OTA4MSAxNy40NjI3IDIgMTYuOCAySDcuMloiIHN0cm9rZT0iIzNGODVFRiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuMiAyMkM2LjUzNzI2IDIyIDYgMjEuNDA5MiA2IDIwLjY4MDRWMTguNTk4QzYgMTQuOTU0IDguNjg2MjkgMTIgMTIgMTJDMTUuMzEzNyAxMiAxOCAxNC45NTQgMTggMTguNTk4VjIwLjY4MDRDMTggMjEuNDA5MiAxNy40NjI3IDIyIDE2LjggMjJINy4yWiIgc3Ryb2tlPSIjM0Y4NUVGIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNyAyMkMxNi4wMTk1IDE5LjkwNDggMTUgMTggMTIgMThDOSAxOCA3Ljk4MDQ1IDE5LjkwNDggNyAyMiIgc3Ryb2tlPSIjM0Y4NUVGIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";